<template>
  <div class="form-wrapper">
    <!-- Loading 弹窗 -->
    <transition name="fade">
      <div class="modal-mask" v-if="popup.loading">
        <div class="modal-box">
          <div class="spinner"></div>
          <p>Submitting your inquiry…</p>
        </div>
      </div>
    </transition>

    <!-- Success 弹窗 -->
    <transition name="fade">
      <div class="modal-mask" v-if="popup.success">
        <div class="modal-box success">
          <div class="icon-check">✓</div>
          <p>Your inquiry has been sent successfully!</p>
        </div>
      </div>
    </transition>

    <form @submit.prevent="handleSubmit" class="form-container">
      <div class="form-header">
        <h2 class="form-title">Reach Out for Fast Solutions​</h2>
        <p class="form-subtitle">
          Complete this simple form and our specialists will contact you within
          24 hours
        </p>
      </div>

      <!-- 标题 -->
      <div class="form-item">
        <input
          type="text"
          placeholder="Subject of Inquiry"
          v-model="formData.subject"
          required
        />
      </div>

      <!-- 主要内容 -->
      <div class="form-item">
        <textarea
          placeholder="Please describe your project details (machinery name, specs, quantity, etc.)"
          rows="7"
          v-model="formData.details"
          required
        ></textarea>
      </div>

      <!-- 联系信息 -->

      <div class="form-item">
        <input
          type="text"
          placeholder="Company Name (Required)"
          v-model="formData.company"
          required
        />
      </div>

      <div class="form-item">
        <input
          type="text"
          placeholder="Your Full Name (Required)"
          v-model="formData.fullName"
          required
        />
      </div>

      <div class="form-item">
        <input
          type="email"
          placeholder="Business Email (Required)"
          v-model="formData.email"
          required
        />
      </div>

      <!-- 新增 Country 字段 -->
      <div class="form-item">
        <input
          type="text"
          placeholder="Your Country (Required)"
          v-model="formData.country"
          required
        />
      </div>

      <div class="form-item">
        <input
          type="tel"
          placeholder="Phone Number (Required)"
          v-model="formData.phone"
          pattern="[0-9]{7,15}"
          required
        />
      </div>

      <div class="form-item">
        <input
          type="url"
          placeholder="Company Website (Optional)"
          v-model="formData.website"
        />
      </div>

      <!-- 提交 -->
      <div class="form-item btn-submit">
        <button type="reset" class="reset-btn">Clear Form</button>
        <button type="submit" class="submit-btn">Send Inquiry</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        subject: "",
        details: "",
        company: "",
        fullName: "",
        email: "",
        country: "",
        phone: "",
        website: "",
      },

      popup: {
        loading: false,
        success: false,
      },
    };
  },

  methods: {
    async handleSubmit() {
      this.popup.loading = true;

      try {
        const res = await fetch("/api/contact", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.formData),
        });

        if (!res.ok) throw new Error("Submission failed");

        this.popup.loading = false;
        this.popup.success = true;

        // success 自动关闭
        setTimeout(() => {
          this.popup.success = false;
        }, 1800);

        // 清空表单
        this.formData = {
          subject: "",
          details: "",
          company: "",
          fullName: "",
          email: "",
          country: "",
          phone: "",
          website: "",
        };
      } catch (err) {
        console.error(err);
        this.popup.loading = false;
        alert("Failed to send inquiry. Please try again later.");
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

/* ============ 手机端 form-wrapper padding 优化 ============ */
.form-wrapper {
  padding: 0.2rem;

  .tablet-up({
    padding: 0;
  });

  .desktop-up({
    padding: 0;
  });
}

/* ============ 原有样式不变，仅保留你旧风格 ============ */
.form-container {
  width: 100%;
  background: lighten(@color-bg-light, 20%);

  .desktop-up({
    margin-right: 2rem;
    padding: none;
  });

  .tablet-up({
    margin-right: 2rem;
    padding: none;
  });

  .form-header {
    margin-bottom: 2rem;
    text-align: center;
  }

  .form-title {
    color: #2d4a3a;
    font-size: 1.8rem;
    margin-bottom: 0.8rem;
    line-height: 1.3;

    .tablet-up({
      font-size: 2.2rem;
    });
  }

  .form-subtitle {
    color: #666;
    font-size: 0.95rem;
    max-width: 600px;
    margin: 0 auto;
  }

  .form-item {
    margin-bottom: 1.6rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    input,
    textarea {
      width: 100%;
      padding: 12px;
      border: 1px solid #ced4da;
      border-radius: 0.5rem;
      font-size: 1rem;
      transition: border-color 0.3s ease;

      &:focus {
        border-color: #3a5f49;
        box-shadow: 0 0 0 2px rgba(58, 95, 73, 0.2);
      }
    }
  }

  .btn-submit {
    display: flex;
    gap: 15px;
    margin-top: 2rem;

    button {
      flex: 1;
      padding: 12px;
      border: none;
      border-radius: 0.5rem;
      cursor: pointer;
      font-weight: 500;
      transition: all 0.3s ease;

      &.reset-btn {
        background: #e9ecef;
        color: #495057;

        &:hover {
          background: #dee2e6;
        }
      }

      &.submit-btn {
        background: #3a5f49;
        color: white;

        &:hover {
          background: #2d4a3a;
        }
      }
    }
  }
}

/* ============ 弹窗 ============ */
.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.modal-box {
  background: #fff;
  padding: 22px 28px;
  border-radius: 10px;
  text-align: center;
  min-width: 230px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.modal-box.success {
  border-left: 4px solid #3a5f49;
}

.icon-check {
  font-size: 2.2rem;
  color: #3a5f49;
  font-weight: bold;
}

/* Loading spinner */
.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #ccc;
  border-top-color: #3a5f49;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
